import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgProfileOutline = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.3 8.3C10.0404 8.3 11.45 6.89038 11.45 5.15C11.45 3.40963 10.0404 2 8.3 2C6.55963 2 5.15 3.40963 5.15 5.15C5.15 6.89038 6.55963 8.3 8.3 8.3ZM8.3 9.875C6.19738 9.875 2 10.9303 2 13.025V14.6H14.6V13.025C14.6 10.9303 10.4026 9.875 8.3 9.875Z",
		stroke: "#071F3E"
	})
});
export default SvgProfileOutline;
